<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox" style="width: 100%">
          <el-form ref="form" label-width="110px">
            <el-row>
              <el-col :sm="24" :lg="12" :xl="8">
                <el-form-item label="第一次查重率">
                  <el-radio-group v-model="type1">
                    <el-radio-button v-for="item in dcfws1" :key="item.value" :label="item.value" v-model="item.value">{{ item.label }}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :sm="24" :lg="12" :xl="8">
                <el-form-item label="第二次查重率">
                  <el-radio-group v-model="type2">
                    <el-radio-button v-for="item in dcfws2" :key="item.value" :label="item.value" v-model="item.value">{{ item.label }}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :sm="24" :md="8">
                <el-form-item label="稿件信息">
                  <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe @select-all="selAll" @selection-change="selChange" border style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>
            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>
            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="dcRate1" label="1次查重结果" width="144">
              <template slot-scope="scope">
                {{ setRate(scope.row.dcRate1) }} <a v-show="scope.row.dcFile1 >= 1" @click="downDcFile(scope.row.sn, scope.row.title, scope.row.dcFile1, 1)" target="_blank" class="download">下载查重报告</a>
                <el-upload :action="baseURL + 'recheck/upload/dcFile?articleId=' + scope.row.id + '&type=1'" multiple name="file" :headers="uploadHeaders">
                  <el-button size="mini" type="default"><i class="el-icon-upload"></i>上传查重报告</el-button>
                </el-upload>
              </template>
            </el-table-column>
            <el-table-column prop="dcRate2" label="2次查重结果" width="144">
              <template slot-scope="scope">
                {{ setRate(scope.row.dcRate2) }} <a v-show="scope.row.dcFile2 >= 1" @click="downDcFile(scope.row.sn, scope.row.title, scope.row.dcFile2, 2)" target="_blank" class="download">下载查重报告</a>
                <el-upload v-show="scope.row.dcRate2 != -1" :action="baseURL + 'recheck/upload/dcFile?articleId=' + scope.row.id + '&type=2'" multiple name="file" :headers="uploadHeaders">
                  <el-button size="mini" type="default"><i class="el-icon-upload"></i>上传查重报告</el-button>
                </el-upload>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.status == 3">已退稿</el-tag>
                <el-tag type="success" v-else-if="scope.row.status == 5">已录用</el-tag>
                <el-tag type="primary" v-else-if="scope.row.step == 61">待作者二次改稿</el-tag>
                <el-tag type="primary" v-else-if="scope.row.step == 62">待编辑二次评审</el-tag>
                <el-tag type="primary" v-else-if="scope.row.step == 63">待二次查重</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="sizes,prev, pager, next" :total="total" :page-size="pageSize" :page-sizes="[10, 20, 30, 50]" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
      </div>
    </div>

    <!--el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="EDITOR"></ArticleProcess>
        </div>
      </div>
    </el-drawer-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import http from "@/api/http"
import recheckApi from "@/api/recheck"
import attachApi from "@/api/attach"
import { getToken } from "@/utils/auth"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { PageHeader },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "查重结果查询" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",

      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,

      baseURL: http.defaults.baseURL,

      uploadHeaders: { Authorization: getToken() },
      status: 0,
      uploadFlag: false,
      curArticleId: null,
      curType: 1,

      type1: -1,
      type2: -1,
      dcfws1: [
        { label: "不限", value: -1 },
        { label: "小于20%", value: 1 },
        { label: "介于20%~30%之间", value: 2 },
        { label: "大于30%", value: 3 },
      ],
      dcfws2: [
        { label: "不限", value: -1 },
        { label: "小于20%", value: 1 },
        { label: "介于20%~30%之间", value: 2 },
        { label: "大于30%", value: 3 },
      ],
    }
  },

  created() {
    //this.uploadURL = http.defaults.baseURL + "recheck/upload/dcFile?articleId="+this.curArticleId+"&type="+this.curType
  },

  mounted() {
    this.loadData()
  },

  methods: {
    uploadBefore(file) {
      const isPDF = file.type === "application/pdf"
      //const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isPDF) {
        this.$alert("上传的查重结果文件必须是PDF格式!", "系统提示", {
          confirmButtonText: "确定",
        })
        return false
      }
      if (!isLt5M) {
        this.$alert("上传的查重结果文件不能超过 5MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return isPDF && isLt5M
    },

    uploadSuccess(res) {
      if (res.code == 0) {
        this.$notify({
          title: "成功",
          message: res.msg,
          type: "success",
        })
      } else {
        this.$notify.error({
          title: "错误",
          message: res.msg,
        })
      }
    },

    downDcFile(sn, title, attachId, type) {
      attachApi.downDcFile(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，调查报告文件附件不存在!", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          let attachName = sn + "-" + title + "-" + (type == 2 ? "-2次" : "") + "查重报告.pdf"
          attachUtil.download(res, attachName)
        }
      })
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },

    loadData() {
      this.tableData = []
      /* recheckApi.getDuplicateList(this.f_subjectId, this.f_title, 2, "id", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      }) */

      recheckApi.getAlreadyDuplicateList(this.f_subjectId, this.f_title, this.type1, this.type2, "dc_time", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    setRate(rate) {
      return rate < 0 ? "" : rate + "%"
    },

    output() {
      let selRows = this.$refs.tableData.selection
      let articleIds = []
      selRows.forEach((element) => {
        console.log(element)
        articleIds.push(element.id)
      })

      recheckApi.downloadDuplicate(articleIds).then((res) => {
        if (res.code == 0) {
          window.open(http.defaults.baseURL + res.data)
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.dengJi {
  border: 1px solid #ccc;
  margin-bottom: 25px;
}
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}
.uploading {
  padding: 15px;
  font-size: 12px;
}
</style>
